const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// Use relative /api path when running on custom domain (futuresfury.com)
// Falls back to env URL for preview environments
export const API = (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && !window.location.hostname.includes('preview.emergentagent.com'))
  ? '/api'
  : `${BACKEND_URL}/api`;

export const ACCOUNT_SIZES = [
  { size: "$25K", label: "25K", popular: false },
  { size: "$50K", label: "50K", popular: true, badge: "BEST VALUE" },
  { size: "$100K", label: "100K", popular: true, badge: "MOST POPULAR" },
  { size: "$150K", label: "150K", popular: false },
  { size: "$200K", label: "200K", popular: false },
  { size: "$250K", label: "250K", popular: false },
  { size: "$300K", label: "300K", popular: false }
];

export const EVALUATION_TYPES = [
  { id: "1-step", label: "1 Step Challenge" },
];

export const NON_PUBLIC_EVAL_TYPES = ['instant-funded', 'instant-prime'];
export const isPublicEvalType = (evalType) => !NON_PUBLIC_EVAL_TYPES.includes(evalType);
export const getStandardPricing = (firm) => (firm?.pricing || []).filter(p => isPublicEvalType(p.evaluation_type));
export const getStandardEvalType = (firm) => {
  const types = (firm?.supported_eval_types || []).filter(isPublicEvalType);
  const pricing = firm?.pricing || [];
  // Prefer eval types that actually have pricing data
  const withPricing = types.filter(t => pricing.some(p => p.evaluation_type === t));
  return withPricing[0] || types[0] || (firm?.pricing?.find(p => isPublicEvalType(p.evaluation_type))?.evaluation_type) || '1-step';
};
